import React, { useState } from 'react'
import { change, Field } from 'redux-form'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import LocalizedDatePicker from './LocalizedDatePicker'


const styles = {
  input: {
    color: 'black',
    fontSize: '1rem',
    backgroundColor: 'rgb(0,0,0,.12))',
  },

  root: {
    color: 'black',
  },
  focused: {
    color: 'black',
    backgroundColor: 'rgb(0,0,0,.12))',
    '&$focused': {
      color: 'black',
      backgroundColor: 'rgb(0,0,0,.12))',
    },
  },
  error: {
		padding: '0 0 10px 0',
		margin: '0',
	}
}

const useLabelStyles = makeStyles({
  root: {
    color: 'black',
    backgroundColor: 'rgb(0,0,0,.12))',
  },
  focused: {
    color: 'black',
    backgroundColor: 'rgb(0,0,0,.12))',
    '&$focused': {
      color: 'black',
      backgroundColor: 'rgb(0,0,0,.12))',
    },
  },
  error: {
		padding: '0 0 10px 0',
		margin: '0'
	}
})

const useInputStyles = makeStyles({
  root: {
    color: 'black',
    position: 'relative',
    fontSize: '16px',
    transition: 'background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    backgroundColor: 'rgba(0, 0, 0, 0.09)',
    'border-top-left-radius': '4px',
    'border-top-right-radius': '4px',
  },
  focused: {
    color: 'black',
    backgroundColor: 'rgb(0,0,0,.12)',
    '&$focused': {
      color: 'black',
      backgroundColor: 'rgb(0,0,0,.12))',
    },
  },
  error: {
    color: 'var(--palette-error-main)',
    padding: '0 0 10px 0',
		margin: '0',
    backgroundColor: 'rgb(0,0,0,.12)',
    '&$focused': {
      color: 'var(--palette-error-main)',
      backgroundColor: 'rgb(0,0,0,.12))',
    },
  },
})

const useHelperStyles = makeStyles({
	root: {
		padding: '0 0 10px 0', 
    margin: '0', 
    backgroundColor: 'white'
	}
})

const renderTextField = ({
  classes,
  label,
  input,
  meta: { touched, invalid, error, form, dispatch },
  inputLabelProps,
  inputProps,
  style,
  fullWidth,
  margin,
  variant,
  type,
  labelStyles,
  inputStyles,
  helperStyles,
  maxLength,
  setHasFocus,
  hasFocus,
  openToYear,
  disablePast,
  ...custom
}) => {

  const handleChange = (date) => {
		dispatch(change(form, input.name, date));
	}

  return (
    <div class="birthDateClass" className="global-input-wrapper">
      <FormControl variant={variant} error={touched && invalid} fullWidth>
        <LocalizedDatePicker
					label={label}
					onDateChange={handleChange}
					error={error}
					defaultDate={input && input.value || null}
					inputProps={{
						style: { color: 'black' }
					}}
					openToYear={openToYear}
          touched={touched}
          externalHelperStyles={helperStyles}
          disablePast={disablePast}
				/>
      </FormControl>
    </div>
  )
}

const FormDateField = ({
  classes,
  label,
  name,
  inputLabelProps,
  inputProps,
  style,
  fullWidth,
  margin,
  variant,
  type,
  validators,
  maxLength = 10,
  openToYear,
  disablePast
}) => {
  var labelStyles = useLabelStyles()
  var inputStyles = useInputStyles()
  var helperStyles = useHelperStyles()
  const [hasFocus, setHasFocus] = useState(false)
  return (
    <Field
      name={name}
      hasFocus={hasFocus}
      setHasFocus={setHasFocus}
      component={renderTextField}
      label={label}
      inputLabelProps={inputLabelProps}
      inputProps={inputProps}
      style={style}
      fullWidth={fullWidth}
      margin={margin}
      variant={variant}
      type={type}
      validate={validators}
      maxLength={maxLength}
      classes={classes}
      labelStyles={labelStyles}
      inputStyles={inputStyles}
      helperStyles={helperStyles}
      openToYear={openToYear}
      disablePast={disablePast}
    />
  )
}

export default withStyles(styles)(FormDateField)
